<template>
	<div :class="`flex flex-col rounded-lg bg-linear-to-br from-white dark:from-gray-900 ${danger ? 'to-red-50 dark:to-red-950' : 'to-gray-50 dark:to-gray-950'} shadow-md dark:shadow-black`">
		<template v-if="hasImage">
			<img v-if="image" :src="storage(image)" class="h-24 object-cover object-center bg-gray-100 dark:bg-gray-900 rounded-t-lg" :alt="imageAlt ?? ''">
			<div v-else class="h-24 bg-gray-100 dark:bg-gray-900 rounded-t-lg flex items-center justify-center">
				<i class="fa-solid fa-image fa-4x"/>
			</div>
		</template>
		<div v-if="$slots.badges || title || subtitle" class="mx-4 pt-4 pb-3 flex flex-col">
			<div v-if="$slots.badges" class="flex items-center justify-between gap-3 mb-2"><slot name="badges"/></div>
			<p v-if="title" class="text-xl font-bold uppercase">{{ title }}</p>
			<p v-if="subtitle" class="text-gray-500">{{ subtitle }}</p>
		</div>
		<div :class="`${noGrow ? '' : 'grow'} p-4 flex flex-col items-stretch justify-end gap-3`">
			<slot/>
			<div v-if="noGrow" class="grow"/>
			<div v-if="$slots.footer" class="pt-4 flex items-center justify-between flex-wrap gap-3">
				<slot name="footer"/>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'
import {storage} from '@/Helpers/general'

defineProps<{
	title?:string,
	image?:string,
	danger?:boolean,
	noGrow?:boolean,
	bgImage?:string,
	subtitle?:string,
	imageAlt?:string,
	hasImage?:boolean,
}>()
</script>